export default {
  how_to_place_order: {
    header: 'Hoe plaats ik een bestelling?',
    body: 'Blader eenvoudig door het menu, voeg items toe aan je winkelwagen en volg de afrekenstappen. Je ontvangt een bevestiging zodra de bestelling is geplaatst.',
  },
  schedule_order: {
    header: 'Kan ik een bestelling van tevoren inplannen?',
    body: 'Ja! Kies bij het afrekenen de optie „Inplannen" om een toekomstige afhaaltijd in te stellen die het beste bij jou past.',
  },
  customize_order: {
    header: 'Kan ik mijn bestelling aanpassen?',
    body: 'Zeker. Tik op een menu-item om aanpassingsopties te zien, zoals toppings, bijgerechten en voorkeuren.',
  },
  track_order: {
    header: 'Hoe volg ik mijn bestelling?',
    body: 'Na het plaatsen van je bestelling zie je realtime updates in de app — van bevestiging tot voorbereiding en klaarmelding.',
  },
  cancel_or_edit_order: {
    header: 'Kan ik mijn bestelling annuleren of wijzigen na het plaatsen?',
    body: 'Als de bereiding van je bestelling nog niet is begonnen, kun je wijzigingen aanvragen door het restaurant rechtstreeks via de app te bellen.',
  },
  payment_methods: {
    header: 'Welke betaalmethoden accepteren jullie?',
    body: 'We accepteren de meeste credit- en betaalkaarten, Apple Pay en Google Pay, afhankelijk van je apparaat.',
  },
  no_confirmation: {
    header: 'Ik heb geen bevestiging ontvangen. Wat moet ik doen?',
    body: 'Controleer de spammap van je e-mail of ga naar het tabblad Bestellingen in de app. Als je het nog steeds niet ziet, neem dan rechtstreeks contact op met het restaurant.',
  },
  pickup_instructions: {
    header: 'Waar haal ik mijn bestelling op?',
    body: 'Afhalinstructies worden getoond op het bevestigingsscherm en in je besteloverzicht. Zoek naar bewegwijzering of vraag het personeel bij aankomst.',
  },
  loyalty_points: {
    header: 'Kan ik loyaliteitspunten verdienen met mijn bestellingen?',
    body: 'Ja, in aanmerking komende aankopen leveren automatisch punten op. Je kunt je saldo en beloningen bekijken in het hoofdscherm van de app.',
  },
  apply_promo_code: {
    header: 'Hoe gebruik ik een promotiecode of korting?',
    body: 'Tijdens het afrekenen zie je een optie om een promotiecode in te voeren. Beschikbare kortingen worden ook automatisch toegepast als je ervoor in aanmerking komt.',
  },
  issue_with_order: {
    header: 'Wat moet ik doen als er een probleem is met mijn bestelling?',
    body: 'We helpen je graag. Neem via de app contact op met het restaurant of stuur een e-mail naar support via de optie Ondersteuning contacteren.',
  },
  use_loyalty_and_coupon: {
    header: 'Kan ik loyaliteitspunten en een coupon (zoals Koop 1 Krijg 1 Gratis) gebruiken voor dezelfde bestelling?',
    body: 'Nee — slechts één korting of aanbieding kan per bestelling worden toegepast. Dit zorgt voor eerlijk gebruik van beloningen en promoties. Kies de optie die je de meeste waarde geeft!',
  },
};
